import { z } from 'zod';

export const membershipSchema = z.object({
  name: z.string().min(2, { message: "Name must be at least 2 characters." }),
  email: z.string().email({ message: "Invalid email address." }),
  phone: z.string().min(10, { message: "Phone number must be at least 10 digits." }),
});

export const campaignSchema = z.object({
  name: z.string().min(3, { message: "Campaign name must be at least 3 characters." }),
  description: z.string().optional(),
  campaign_type: z.enum(['workflow', 'one_time_email', 'one_time_sms', 'multi_channel']),
  segment_id: z.string().uuid({ message: "Please select a valid segment." }).optional().nullable(),
  workflow_id: z.string().uuid({ message: "Please select a valid workflow." }).optional().nullable(),
});

export const templateSchema = z.object({
  name: z.string().min(2, { message: "Template name must be at least 2 characters." }),
  category: z.enum(['email', 'sms', 'ai_call']),
});

export const segmentSchema = z.object({
  name: z.string().min(2, { message: "Segment name must be at least 2 characters." }),
  description: z.string().optional(),
  criteria: z.any(),
});
